<template>
  <div class="main-body margin_bottom" style="color: white">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <AdminChannelViewLayout></AdminChannelViewLayout>
    <hr class="bg-white" />
    <div class="container-fluid">
      <div class="card mt-3 text-white bg-dark">
        <div v-if="pendingPage" class="mt-3">
          <span class="m-3">Pending Audio Book List</span>
          <div class="card-body">
            <div class="table-responsive-sm">
              <table class="custom_table">
                <thead>
                  <tr>
                    <td>#</td>
                    <td>Name</td>
                    <td>Author Name</td>
                    <td>Contributing Artist</td>
                    <td>Price</td>
                    <td>Publish Year</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(audiobook, index) in audiobooks" :key="index">
                    <td>
                      <a class="btn">
                        <i class="far fa-play-circle" style="color: white"></i>
                      </a>
                    </td>
                    <td>{{ audiobook.name }}</td>
                    <td>{{ audiobook.category_name }}</td>
                    <td>{{ audiobook.author_name }}</td>
                    <td>{{ audiobook.price }}</td>
                    <td v-if="audiobook.approval_status == 0">Pending</td>
                    <td v-else-if="audiobook.approval_status == 1">Approved</td>
                    <td v-else-if="audiobook.approval_status == 2">Rejected</td>
                    <td>
                      <h6>
                        <span
                          class="badge bg-info"
                          style="cursor: pointer"
                          v-on:click="veiwStatus(audiobook.id)"
                        >
                          View</span
                        >&ensp;
                        <span
                          v-on:click="updateStatus(audiobook.id, 1)"
                          class="badge bg-success"
                          style="cursor: pointer"
                          >Approve</span
                        >&ensp;
                        <span
                          class="badge bg-danger"
                          style="cursor: pointer"
                          v-on:click="deleteAudioBookData(audiobook.id, 1)"
                          >Delete</span
                        >&ensp;
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import AdminChannelViewLayout from "../layouts/AdminChannelViewLayout";
export default {
  name: "Reject",
  components: { Loading, AdminChannelViewLayout },
  data() {
    return {
      channelId: localStorage.getItem("tempChannelId"),
      audiobooks: [],
      allData: [],
      rejectData: [],
      pendingPage: true,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl +
            this.$api +
            this.$version3 +
            "/audiobooks/rejected-by-channelId/" +
            this.channelId,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.audiobooks = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    veiwStatus(id) {
      this.$router.push("/audiobook/" + id);
    },
    //  async getRejectData() {
    //   console.log(this.pendingPage);
    //   this.isLoading = true;
    //   const token = localStorage.getItem(this.$tokenKey);
    //   try {
    //     const res = await axios.get(
    //       this.$baseUrl + this.$api + this.$version1 + "/audiobooks/rejected",
    //       {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );
    //     this.isLoading = false;
    //     if (res.status == 200) {
    //       console.log(res.data);
    //       this.rejectData = res.data;
    //     } else {
    //       this.$vToastify.error("Could not fetch data!");
    //     }
    //   } catch (error) {
    //     console.log(error);
    //     this.isLoading = false;
    //   }
    // },
    async updateStatus(id, status) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/audiobooks/pendings/update/" +
            id,
          {
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        console.log(res);
        if (res.data.success == true) {
          switch (status) {
            case 1: {
              this.$vToastify.info("AudioBook Approved");
              break;
            }
            case 2: {
              this.$vToastify.info("AudioBook Rejected");
              //this.getRejectData();
              break;
            }
          }
          this.getData();
          //this.getRejectData();
        } else {
          this.$vToastify.error("Something went wrong");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async deleteAudioBookData(id, status) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/audiobooks/delete" +
            "?audio_bookId=" +
            id,
          {
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.getData();
          console.log(res);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
  mounted() {
    // use this for get
    this.getData();
  },
};
</script>

<style scoped>
@import "../../assets/css/audioBook.scss";
@import "../../assets/css/audioNav.scss";
</style>